import React from 'react';
import { Modal, Card } from 'antd';
import { CloseSvg } from 'utils/svgs';
import styles from './index.module.scss';

interface ExpenseJournalDeleteModalProps {
	isOpen: boolean;
	onCancel: () => void;
	onConfirm: () => void;
	isLoading: boolean;
	journalStatus: 'Published' | 'Draft';
	journalNumber?: string;
}

const ExpenseJournalDeleteModal: React.FC<ExpenseJournalDeleteModalProps> = ({
	isOpen,
	onCancel,
	onConfirm,
	isLoading,
	journalStatus,
	journalNumber,
}) => {
	const isPublished = journalStatus === 'Published';

	return (
		<Modal
			title={
				<div className={styles['delete-modal__title']}>
					<h4 className={styles['delete-modal__title-text']}>
						Confirm Deletion
					</h4>
				</div>
			}
			open={isOpen}
			onCancel={onCancel}
			centered={true}
			width={500}
			closeIcon={<CloseSvg />}
			footer={[
				<div key="footer" className={styles['delete-modal__footer']}>
					<button
						key="cancel"
						onClick={onCancel}
						className={styles['delete-modal__button--cancel']}
						disabled={isLoading}
					>
						Cancel
					</button>
					<button
						key="delete"
						onClick={onConfirm}
						className={styles['delete-modal__button--delete']}
						disabled={isLoading}
					>
						{isLoading ? (
							<img src="assets/gifs/loading-black.gif" height={30} />
						) : (
							'Yes! Delete'
						)}
					</button>
				</div>,
			]}
		>
			<div className={styles['delete-modal__content']}>
				<p className={styles['delete-modal__message']}>
					Are you sure you want to delete this expense journal
					{isPublished && journalNumber && ` #${journalNumber}`}?
				</p>

				<Card className={styles['delete-modal__warning-card']}>
					<p className={styles['delete-modal__warning-text']}>
						{isPublished ? (
							<>
								<strong>Warning:</strong> This journal has been published to
								QuickBooks Online. Deleting it will also remove it from
								QuickBooks Online and cannot be undone.
							</>
						) : (
							<>
								<strong>Warning:</strong> This journal is currently in draft
								status. Deleting it will permanently remove all associated data
								and cannot be recovered.
							</>
						)}
					</p>
				</Card>
			</div>
		</Modal>
	);
};

export default ExpenseJournalDeleteModal;
